import CollapsibleSection from 'src/components/CollapsibleSection';
import { publishTimes } from 'src/components/PublishDetailsView/shared';
import { getPublishTime } from '../getPublishTime/getPublishTime';

interface IPublishedTimeSummarySectionProps {
  number: string;
  publicationDate: string;
  publicationType: publishTimes;
}

const PublishedTimeSummarySection = ({
  number,
  publicationDate,
  publicationType,
}: IPublishedTimeSummarySectionProps) => (
  <CollapsibleSection
    number={number}
    title="Published date & time"
    subtitle={getPublishTime(publicationDate, publicationType)}
  />
);

export default PublishedTimeSummarySection;
